import { useEffect, useState } from 'react';

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState<any>({
        width: undefined,
        height: undefined,
    });
    const [isSmall, setIsSmall] = useState(false);
    const [isMedium, setIsMedium] = useState(false);
    const [isLarge, setIsLarge] = useState(false);
    const PHONE_SCREEN = 540;
    const TABLET_SCREEN = 1367;
    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window?.innerWidth,
                height: window?.innerHeight,
            });
            const size = window?.innerWidth;
            if (size <= PHONE_SCREEN) {
                setIsSmall(true);
                setIsMedium(false);
                setIsLarge(false);
            } else if (size <= TABLET_SCREEN) {
                setIsSmall(false);
                setIsMedium(true);
                setIsLarge(false);
            } else {
                setIsSmall(false);
                setIsMedium(false);
                setIsLarge(true);
            }
        }
        window?.addEventListener('resize', handleResize);
        handleResize();
        return () => window?.removeEventListener('resize', handleResize);
    }, []);
    return [windowSize, isSmall, isMedium, isLarge];
}
